"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var shop_1 = require("../controllers/shop");
var Tab = /** @class */ (function () {
    function Tab() {
        this.init();
    }
    Tab.getInstance = function () {
        return new Tab();
    };
    Tab.prototype.init = function () {
        var $tabs = $('[data-tab]'), $groupContainer = $('[data-group-container]');
        $tabs.on('click', function () {
            window.history.pushState({}, "", $(this).attr('data-url'));
            $tabs.removeClass('active');
            $(this).addClass('active');
            $.ajax({
                url: $(this).attr('data-url')
            }).done(function (data) {
                if (data.items) {
                    $groupContainer.html(data.items);
                    shop_1.default.getInstance(true).initCardModal();
                }
            });
        });
    };
    return Tab;
}());
exports.default = Tab;
